<template>
    <div class="modal-wrap ml20 mr20">
        <p class="text-bold tac mb10">存在多个任务，无法自动匹配，请选择一个任务进行上传</p>
        <el-form ref="form" label-width="150px" :model="formItem" class="form-wrap pr20">
            <el-form-item :prop="item" :label="'尺寸'+item+'：'" v-for="item in repeatList" :key="item" :rules="{required:true,message:'请选择任务',trigger: 'blur'}">
                <div class="mt10">
                    <el-radio-group v-model="formItem[item]">
                        <el-radio v-for="inner in repeatTaskList[item]" :label="inner.assign_id" :key="inner.assign_id" class="mb10 block pre-wrap">
                            任务ID{{inner.id}}/{{item}}/{{inner.material_size+inner.material_size_unit}}
                            <span v-if="inner.material_duration">/{{inner.material_duration}}s</span>
                            /{{(inner.producer||[]).map(i=>i.name).join('，')}}/{{inner.material_num}}/{{inner.finish_time}}
                        </el-radio>
                    </el-radio-group>
                </div>
            </el-form-item>
        </el-form>
        <div class="dialog-footer pt20 tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">确认</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RepeatSizeModal",
        props:{
            cbs:{
                type:Object,
            },
            taskList:Array,
            repeatList:Array,
        },
        data(){
            return {
                formItem:{

                },
                rules:{},
            }
        },
        computed:{
            repeatTaskList(){
                let mapData = {};
                for (let item in this.repeatList){
                    let size = this.repeatList[item];
                    console.log(777,size);
                    mapData[size] = (this.taskList||[]).filter(item=>item.width+'*'+item.height==size);
                }
                return mapData;
            },
        },
        mounted(){
            this.initData();
        },
        methods:{
            initData(){
                for (let item in this.repeatList){
                    this.$set(this.formItem,this.repeatList[item],'');
                }
            },
            handleClose() {
                this.$emit('close');
            },
            handleSubmit() {
                this.$refs.form.validate((valid) => {
                    if(valid){
                        this.cbs.onSubmit({...this.formItem});
                        this.handleClose();
                    }else{
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },

    }
</script>

<style lang="scss" scoped>
    .form-wrap{
        max-height: 350px;
        overflow-y: auto;
    }
    .pre-wrap ::v-deep .el-radio__label{
        white-space: pre-wrap;
        display: inline-block;
        vertical-align: text-top;
        line-height: 18px;
        padding-right: 10px;
    }
</style>
